import React from "react";

import AnnouncementBar from "../../../components/AnnouncementBar/AnnouncementBar";
import EditAddressIndex from "../../../components/SidetabPages/Customers/EditAddressIndex";

const EditAddress = () => {
  return (
    <>
      <AnnouncementBar />
      <EditAddressIndex />
    </>
  );
};
export default EditAddress;
